var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-card',{attrs:{"title":"Şirket Hiyerarşisi","code-toggler":""}},[_c('div',[_c('organization-chart',{attrs:{"datasource":_vm.ds},on:{"node-click":_vm.deneme}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }